import React, { Component } from 'react';
import { reduxForm, Field } from 'redux-form';
import {FormattedHTMLMessage} from 'react-intl';

import withAuthControl from '../auth/Auth.js';
import TopScrolleable from './TopScrolleable.js';
import generateValidator from './Validations/generateValidator';
import { capitalizeFirstLetter } from '../utils/utils';
import NATIONALITIES from '../libs/es-nationalities';

import Section from './Section.js';
import CustomDatePicker from './CustomDatePicker';
import CustomSpinner from './CustomSpinner';
import SelectField from './SelectField';
import CustomAlert from '../components/CustomAlert.js';

class ClientInformation extends Component {

    constructor(props) {
        super(props);

    }



    render() {
        const { handleSubmit, submitting, error } = this.props;

        const nationalityOptions = NATIONALITIES.map(n => ({name: capitalizeFirstLetter(n), id: capitalizeFirstLetter(n)}));

        return (
            <Section className="intro_form">
                <div className="row">
                    <div className="pd-content-left col-md-5 col-lg-5 text-center">
                        <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo-h-blanco.png`)}/>
                        <FormattedHTMLMessage id="app.step_client_information" description="Client Information"/>
                        <FormattedHTMLMessage id="app.whatsapp_timetable" description="Wp timetable"/>
                    </div>
                    <div className="pd-content-right col-sm-12 col-md-7 col-lg-7">
                        <form onSubmit={handleSubmit(this.props.saveClientInformation)} className="pvc-form">
                            {this.props.isLoading && <CustomSpinner message='Estamos analizando su solicitud. Por favor espere...' /> }
                            {error && <CustomAlert bsStyle="danger" message={error}/>}
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                    <div className="form-group">
                                        <Field name="birth_date" props={{placeholder: 'Fecha de Nacimiento'}} component={CustomDatePicker} renderMonthElement={true} label="Fecha de Nacimiento"/>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                    <div className="form-group">
                                        <Field
                                            className="form-control"
                                            name="nationality"
                                            component={SelectField}
                                            options={nationalityOptions}
                                            defaultValue={'Nacionalidad'}
                                            label={'Nacionalidad'}
                                            type={'select'}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                                    <button type="submit" className="btn btn-warning btn-lg pd-button pd-form" disabled={submitting}>Seguir</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </Section>
        );
    }
}

ClientInformation.contextTypes = {
    intl: React.PropTypes.object.isRequired
}

let validate = generateValidator([{name: 'birth_date', required: true},
                                  {name: 'nationality', required: true}])
ClientInformation = TopScrolleable(ClientInformation);

ClientInformation = reduxForm({
    form: 'ClientInformation', // a unique name for this form
    validate
})(ClientInformation);

ClientInformation = withAuthControl(ClientInformation);

export default ClientInformation;


/** WEBPACK FOOTER **
 ** ./src/components/ClientInformation.js
 **/